import React from 'react'

import { Text, TextName } from 'sdk'
import { TechBenefitsCard } from 'pages/home-page/components/tech-benefits-card/TechBenefitsCard'

import type { SoundcorePerformanceSpecsCmsContent } from 'core/services/cms/interfaces'

import { IntegrationSupportCard } from '../../components/integration-support-card/IntegrationSupportCard'

import classes from './PerformanceSpecsSection.module.scss'


interface PerformanceSpecsSectionProps {
  content: SoundcorePerformanceSpecsCmsContent
}

const PerformanceSpecsSection: React.FC<PerformanceSpecsSectionProps> = ({ content }) => {
  return (
    <section className={classes.performanceSpecsSection}>
      <Text type={TextName.H2} className={classes.heading}>
        {content.title}
      </Text>
      <div className={classes.cards}>
        {content.cards.map((spec) => (
          <TechBenefitsCard
            key={spec.title}
            title={spec.title}
            body={spec.body}
          />
        ))}
      </div>
      <IntegrationSupportCard
        title={content.integrationSupportTitle}
        body={content.integrationSupportBody}
        className={classes.integrationCard}
      />
    </section>
  )
}

export default PerformanceSpecsSection
